import { jsx as _jsx } from "react/jsx-runtime";
import { withStyle } from 'styletron-react';
import { StyledLayoutBase, layoutBasePropsToStyledProps } from './LayoutBase';
const StyledRelativeContainer = withStyle(StyledLayoutBase, {
    position: 'relative',
});
export const RelativeContainer = ({ children, ...layoutBaseProps }) => (_jsx(StyledRelativeContainer, { ...layoutBasePropsToStyledProps(layoutBaseProps), children: children }));
